<template>
    <div class="rent-container">
      <div class="rent-card">
        
        <!-- Top Branding Section -->
        <header class="rent-header">
          <!-- <div class="main-badge">
            <div class="icon-bg">
             
              <svg viewBox="0 0 24 24" class="icon-transfer" fill="none" xmlns="http://w3.org">
                <path d="M4 8H17M17 8L13 4M17 8L13 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20 16H7M7 16L11 12M7 16L11 20" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
       
            <div class="floating-badge">
                <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 9C12.1667 9 11.4583 8.70833 10.875 8.125C10.2917 7.54167 10 6.83333 10 6C10 5.16667 10.2917 4.45833 10.875 3.875C11.4583 3.29167 12.1667 3 13 3C13.8333 3 14.5417 3.29167 15.125 3.875C15.7083 4.45833 16 5.16667 16 6C16 6.83333 15.7083 7.54167 15.125 8.125C14.5417 8.70833 13.8333 9 13 9ZM6 12C5.45 12 4.97917 11.8042 4.5875 11.4125C4.19583 11.0208 4 10.55 4 10V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H20C20.55 0 21.0208 0.195833 21.4125 0.5875C21.8042 0.979167 22 1.45 22 2V10C22 10.55 21.8042 11.0208 21.4125 11.4125C21.0208 11.8042 20.55 12 20 12H6ZM8 10H18C18 9.45 18.1958 8.97917 18.5875 8.5875C18.9792 8.19583 19.45 8 20 8V4C19.45 4 18.9792 3.80417 18.5875 3.4125C18.1958 3.02083 18 2.55 18 2H8C8 2.55 7.80417 3.02083 7.4125 3.4125C7.02083 3.80417 6.55 4 6 4V8C6.55 8 7.02083 8.19583 7.4125 8.5875C7.80417 8.97917 8 9.45 8 10ZM19 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V3H2V14H19V16ZM6 10V2V10Z" fill="#0024AE"/>
                </svg>

            </div>
          </div> -->
          <h1 class="main-title">Advance Rent</h1>
          <p class="main-subtitle">Access your rental income before the due date.</p>
        </header>

        <section>
            <div class="" style="background: linear-gradient(135deg, rgba(0, 51, 234, 0.1) 0%, rgba(0, 36, 174, 0.2) 100%); padding: 40px; border-radius: 16px;">
                <div style="background-color: #ffffff; border-radius: 16px; padding: 24px; box-shadow: 0px 8px 10px -6px #0000001A; box-shadow: 0px 20px 25px -5px #0000001A;
">
                    <div>
                        <svg width="54" height="43" viewBox="0 0 54 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.5333 30.6667C23.6444 31.7778 25.0444 32.3 26.7333 32.2333C28.4222 32.1667 29.6444 31.5556 30.4 30.4L45.3333 8L22.9333 22.9333C21.7778 23.7333 21.1444 24.9444 21.0333 26.5667C20.9222 28.1889 21.4222 29.5556 22.5333 30.6667ZM8.26667 42.6667C7.28889 42.6667 6.38889 42.4556 5.56667 42.0333C4.74444 41.6111 4.08889 40.9778 3.6 40.1333C2.44444 38.0444 1.55556 35.8778 0.933333 33.6333C0.311111 31.3889 0 29.0667 0 26.6667C0 22.9778 0.7 19.5111 2.1 16.2667C3.5 13.0222 5.4 10.2 7.8 7.8C10.2 5.4 13.0222 3.5 16.2667 2.1C19.5111 0.7 22.9778 0 26.6667 0C30.3111 0 33.7333 0.688889 36.9333 2.06667C40.1333 3.44444 42.9333 5.32222 45.3333 7.7C47.7333 10.0778 49.6444 12.8556 51.0667 16.0333C52.4889 19.2111 53.2222 22.6222 53.2667 26.2667C53.3111 28.7111 53.0333 31.1 52.4333 33.4333C51.8333 35.7667 50.9111 38 49.6667 40.1333C49.1778 40.9778 48.5222 41.6111 47.7 42.0333C46.8778 42.4556 45.9778 42.6667 45 42.6667H8.26667Z" fill="#0033EA"/>
                        </svg>

                    </div>
                    <div>
                        <svg width="96" height="6" viewBox="0 0 96 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_8555_41143)">
                            <rect width="96" height="6" rx="3" fill="#F1F5F9"/>
                            <rect width="72" height="6" rx="3" fill="#0033EA"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_8555_41143">
                            <rect width="96" height="6" rx="3" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <h6 class="disbursement-text">FAST DISBURSEMENT</h6>
                </div>
            </div>
        </section>
  
  
        <!-- Benefits & Features Checklist List -->
        <main class="benefits-list">
          
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
              <svg viewBox="0 0 24 24" class="b-icon" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <circle cx="12" cy="16" r="1"/>
              </svg>
            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">Get Funds Early</h3>
              <p class="benefit-desc">Access up to 6 months of rent upfront instantly.</p>
            </div>
          </div>
  
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM2 6V4V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z" fill="#0033EA"/>
                </svg>

            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">Flexible Repayment</h3>
              <p class="benefit-desc">Pay back conveniently from future rent collections.</p>
            </div>
          </div>
  
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.55 16.2L11.725 10H7.725L8.45 4.325L3.825 11H7.3L6.55 16.2ZM4 20L5 13H0L9 0H11L10 8H16L6 20H4Z" fill="#0033EA"/>
                </svg>

            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">Fast Access</h3>
              <p class="benefit-desc">Approval in under 24 hours with minimal paperwork.</p>
            </div>
          </div>
  
        </main>
  

        <section class="workflow-section">
          <h2 class="section-title">How It Works</h2>
          
          <div class="timeline">
            <div v-for="(step, index) in steps" :key="index" class="timeline-item">
              <div class="timeline-badge">
                <span class="step-number">{{ step.number }}</span>
              </div>
              <div class="timeline-content">
                <p class="step-text">{{ step.text }}</p>
                <h6 class="step-desc">{{ step.desc }}</h6>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h3 class="checklist-header">Transparent Terms</h3>
          <div class="checklist-card">
            <ul class="checklist-items">
                <li v-for="(item, index) in checklist" :key="index" class="checklist-item">
                    <div class="check-icon-wrapper">
                        <!-- Verified Circle Check Blue SVG Icon -->
                        <svg viewBox="0 0 24 24" class="svg-check-icon">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                    </div>
                    <span class="item-label">{{ item }}</span>
                </li>
            </ul>
          </div>
        </section>

      
        <div class="button-holder">
          <button class="btn" @click="routeTo()">Continue</button>
        </div>
  
      </div>
    </div>
</template>

<script>
  export default {
    name: 'AdvanceHome',
        data() {
            return {
                steps: [
                    { number: 1, text: 'Enter Amount', desc: "Specify how much advance rent you need." },
                    { number: 2, text: 'Review', desc: "Check terms, and charges." },
                    { number: 3, text: 'Receive funds', desc: "Fund is sent to your SAFE once approved." },
                ],
                checklist: [
                    'Fixed Charges',
                    'No Hidden Fees',
                ]
            };
        },
        beforeDestroy() {
          sessionStorage.removeItem('unitSelections');
        },
        methods: {
          goBack() {
            this.$router.go(-1)
          },
          routeTo() {
            this.$router.push("advance-rent-amount");
          },
        }
  };
</script>

<style scoped lang="scss">


// Color Declarations
$bg-main: #f8fafd;
$card-white: #ffffff;
$color-bg-card: #ffffff;
$primary-blue: #0047ff;
$color-brand-blue: #0046ff;
$color-brand-light-blue: #eef2ff;
$color-brand-dark-blue: #0033EA;
$text-dark: #111625;
$text-muted: #58627a;
$alert-bg: #003ce6;
$tint-blue: #edf2ff;
$rec-bg: #E8E7F5;
$color-text-dark: #090e1a;
$color-bg-checklist: #e8ecfc;
$color-bg-notice: #f0f3fa;
$color-text-dark: #090e1a;
$color-text-muted: #4e5668;

// Main Structural Frame Wrapper
.rent-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: $bg-main;
  padding: 1.5rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
}

// Clean Fluid-width Mobile Layout Card
.rent-card {
  background-color: $card-white;
  width: 100%;
  max-width: 420px; 
  border-radius: 28px;
  padding: 2.2rem 1rem;
  //   box-shadow: 0 10px 30px rgba(0, 71, 255, 0.04);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.05), 0 12px 24px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

// Upper Logo Presentation Styles
.rent-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;

  .main-badge {
    position: relative;
    width: 110px;
    height: 110px;
    margin-bottom: 1.2rem;
    
  }


  .main-title {
    font-size: 1.65rem;
    font-weight: 700;
    color: $text-dark;
    letter-spacing: -0.5px;
    margin-bottom: 0.5rem;
  }

  .main-subtitle {
    font-size: 0.98rem;
    color: $text-muted;
    line-height: 1.45;
    max-width: 85%;
  }
}

.disbursement-text {
    font-family: Inter;
    font-weight: 700;
    // font-style: Bold;
    font-size: 14px;
    // line-height: 16px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #0033EA;
    margin-top: 15px;

}


// Core Features Vertical Stack Grid 
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;

  .benefit-card {
    background-color: $card-white;
    border: 1px solid rgba(0, 0, 0, 0.03);
    border-radius: 16px;
    padding: 1.1rem 0.5rem;
    display: flex;
    align-items: center;
    gap: 1.1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }

    .benefit-icon-wrapper {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;

      &.blue-tint {
        background-color: $tint-blue;
        color: $primary-blue;
      }

      .b-icon {
        width: 22px;
        height: 22px;
      }
    }

    .benefit-content {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      text-align: left;

      .benefit-title {
        font-size: 0.95rem;
        font-weight: 600;
        color: $text-dark;
      }

      .benefit-desc {
        font-size: 0.88rem;
        color: $text-muted;
        line-height: 1.35;
      }
    }
  }
}



// Media Breakpoint Adaptability Adjustments for Tablet & Larger Displays
@media (min-width: 480px) {
  .rent-card {
    padding: 2.5rem 2rem;
    max-width: 440px;
  }
}

// Workflow / Timeline Section Styling
.workflow-section {
    width: 100%;
    margin-top: 46px;
    .section-title {
      font-size: 24px;
      font-weight: 700;
      color: $color-text-dark;
      margin: 0 0 28px 0;
      letter-spacing: -0.3px;
      text-align: left;
      font-family: Lato;
    }

    .timeline {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 32px;
      padding-left: 6px;

      // Vertical connecting line running down steps
      &::before {
        content: '';
        position: absolute;
        top: 14px;
        left: 20px;
        bottom: 14px;
        width: 2px;
        background-color: #e2e8f5;
        z-index: 1;
      }

      .timeline-item {
        position: relative;
        display: flex;
        align-items: center;
        gap: 20px;
        z-index: 2;

        .timeline-badge {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: $color-brand-blue;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 4px 10px rgba($color-brand-blue, 0.2);

          .step-number {
            font-size: 14px;
            font-weight: 700;
            color: $color-bg-card;
          }
        }

        .timeline-content {
          .step-text {
            font-size: 17px;
            font-weight: 500;
            color: $color-text-dark;
            margin: 0;
            text-align: left;
            font-family: Lato;
          }
          .step-desc {
            font-size: 14px;
            font-weight: 500;
            color: #444656;
            margin: 0;
            text-align: left;
            font-family: Lato;
          }
        }
      }
    }
  }

  // Requirements Checklist Box Styling
  .checklist-header {
        font-size: 20px;
        font-weight: 700;
        color: #444656;
        letter-spacing: 0.8px;
        margin: 0 0 24px 0;
        font-family: Lato;
        margin-top: 46px;
        text-align: left;
        color: #1A1B24;
        margin-bottom: 15px;
    }
  .checklist-card {
    background-color: $color-bg-checklist;
    border-radius: 16px;
    padding: 24px 22px;
    box-shadow: 0 2px 12px rgba(0, 50, 150, 0.02);
    text-align: left;
    width: 100%;
    // margin-top: 46px;
    margin-bottom: 30px;

    .checklist-items {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 18px;

      .checklist-item {
        display: flex;
        align-items: center;
        gap: 14px;


        .check-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;

          .svg-check-icon {
            width: 21px;
            height: 21px;
            fill: #16A34A;
          }
        }

        .item-label {
          font-size: 16px;
          font-weight: 500;
          color: #3b4254;
          font-family: Lato;
        }
      }
    }
  }

   // Media viewports optimization for minor adjustments
   @media (max-width: 400px) {
    .page-container {
      .workflow-section {
        .section-title {
          font-size: 22px;
        }
        .timeline .timeline-item .step-text {
          font-size: 15.5px;
        }
        .timeline .timeline-item .step-desc {
          font-size: 12.5px;
        }
      }
      
      .checklist-card {
        padding: 20px 16px;
        
        .checklist-items .checklist-item .item-label {
          font-size: 15px;
        }
      }
    }
  }
  
  .button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      background-color: $color-brand-dark-blue;
      color: $color-bg-card;
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
  }



</style>
  